import { loadStripe } from '@stripe/stripe-js';

// Re-export types from stripe_types to maintain backward compatibility
export type {
  SetupIntentResponse,
  SubscriptionPlan,
  CreateSubscriptionRequest,
  SubscriptionStatus,
} from './stripe_types';

// Initialize Stripe with your publishable key
// You should get this from your backend API call
let stripePromise: ReturnType<typeof loadStripe> | null = null;

export const getStripe = (publishableKey?: string) => {
  if (!stripePromise) {
    if (publishableKey) {
      stripePromise = loadStripe(publishableKey);
    } else {
      // Fallback to environment variable or default
      const key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_your_publishable_key_here';
      stripePromise = loadStripe(key);
    }
  }
  return stripePromise;
};
